
export default {
  /**
   * スタイルを保持
   * @param commit
   * @param data
   */
  fetchStyle({ commit }, data) {

    commit("SET_STYLE", data);
  },
  /**
   * センター地点を保持
   * @param commit
   * @param data
   */
  fetchCenter({ commit }, data) {

    commit("SET_CENTER", data);
  },
  setVesselCategories({ commit }, data) {

    commit("SET_VESSEL_CATEGORIES", {
      id: String(data.id),
      value: data.value
    });
  },
  setAllVesselCategories({ commit }, value) {

    commit("SET_ALL_VESSEL_CATEGORIES", value);
  },
  setPlotCategories({ commit }, data) {

    commit("SET_PLOT_CATEGORIES", {
      id: String(data.id),
      value: data.value
    });
  },
  setAllPlotCategories({ commit }, value) {

    commit("SET_ALL_PLOT_CATEGORIES", value);
  },
  /**
   * ズーム値を保持
   * @param commit
   * @param data
   */
  fetchZoom({ commit }, data) {
    commit("SET_ZOOM", data);
  },
  fetchDefaultPosition({ commit }) {

    let lng = localStorage.getItem("lng")
      ? localStorage.getItem("lng")
      : "139.86448000000001";
    let lat = localStorage.getItem("lat")
      ? localStorage.getItem("lat")
      : "35.54817666666667";
    let zoom = localStorage.getItem("zoom") ? localStorage.getItem("zoom") : 13;

    commit("SET_DEFAULT_POSITION", {
      lng: lng,
      lat: lat,
      zoom: zoom
    })
  },
  async saveDefaultPosition(_, data) {
    localStorage.setItem("lng", data.lng);
    localStorage.setItem("lat", data.lat);
    localStorage.setItem("zoom", data.zoom);
  },

}
